import { request } from '../request'

// 委托代码模块的接口

// 获取我承接的问卷
export function myTakeOn(params) {
  return request({
    url: '/quota/wjmyentrust/page',
    method: 'GET',
    params
  })
}

// 根据问卷ID查询任务
export function getTasksById(params) {
  return request({
    url: '/quota/wjmyentrust/getTasks',
    method: 'GET',
    params
  })
}

// 承接/拒绝问卷
export function acceptTask(params) {
  return request({
    url: '/quota/wjmyentrust/acceptTask',
    method: 'GET',
    params
  })
}

// 承接问卷点亮星星的操作
export function starChange(params) {
  return request({
    url: '/quota/wjmyentrust/starEntrustSurvey',
    method: 'GET',
    params
  })
}
